function Footer({ color = "text-gray-100 bg-brand-darker-blue" }) {
  return (
    <>
      <footer
        className={
          "w-full py-5 px-5 text-left font-pretendard mt-auto font-thin " + color
        }
      >
        © KoolMirco 2025 / All Rights Reserved.
      </footer>
    </>
  );
}

export default Footer;